<template>
	<div>
		<div v-if="type == 'number'">
			{{ value != null ? value.toLocaleString('da-DK') : '' }}
		</div>
        <div v-if="type == 'money' || type == 'price'">
            {{ currency ? currency.code : '' }} {{ value != null ? value.toLocaleString('da-DK') : '' }}
        </div>
		<div v-if="type == 'date'">
			{{ dateFormat(value) }}
		</div>
	</div>
</template>

<script>
export default {
  props: [
    'value',
    'type',
    'time',
    'currency'
  ],
  methods: {
    dateFormat (date, options) {
      if (!options) {
        options = {}
      }

      if (!date) {
                	return 'N/A'
      }

      if (typeof date === 'string') {
        date = new Date(date)
      }

      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

      var year = date.getFullYear()
      var month = months[date.getMonth()]
      var day = date.getDate()
      var hour = date.getHours()
      var min = date.getMinutes()

      if (hour < 10) {
        hour = '0' + hour
      }

      if (min < 10) {
        min = '0' + min
      }

      let out = month + ' ' + day + (year != (new Date()).getFullYear() ? (', ' + year) : '')

      const isToday = ((new Date()).toDateString() == date.toDateString())
      const isTmrw = ((new Date((new Date()).getTime() + 24 * 60 * 60 * 1000))
        .toDateString() == date.toDateString())

      if (isToday) {
        out = 'Today'
      } else if (isTmrw) {
        out = 'Tomorrow'
      }

      return out + (this.time ? (' at ' + hour + ':' + min) : '')
    }
  }
}
</script>
